import { render } from "./RegisterDisbursements.vue?vue&type=template&id=2c0c689b"
import script from "./RegisterDisbursements.vue?vue&type=script&lang=js"
export * from "./RegisterDisbursements.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__